module.exports = __webpack_public_path__ + "static/media/circle-slow-white-32-px.1dba43fd.svg";